import { render, staticRenderFns } from "./surface_section_actions.vue?vue&type=template&id=1f128da0&scoped=true&"
import script from "./surface_section_actions.vue?vue&type=script&lang=js&"
export * from "./surface_section_actions.vue?vue&type=script&lang=js&"
import style0 from "./surface_section_actions.vue?vue&type=style&index=0&id=1f128da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f128da0",
  null
  
)

export default component.exports